<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 详情页头部 -->
      <div class="page-card__header">
        参展展品详情
      </div>

      <!-- 产品详情 -->
      <div class="page-card__body" v-if="UpdateDetailShow == 1" style="text-align: left;font-size: 14px;line-height: 30px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-image
              :src="img" style="width: 275px;height: 275px" fit="cover"></el-image>
          </el-col>
          <el-col :span="18">
            <div style="font-weight: bold;font-size: 16px">{{p_data.title}}</div>
            <div>分类：{{p_data.type}}</div>
            <div style="height: 100px">
              <el-row>
                <el-col :span="2">产品介绍:</el-col>
                <el-col :span="21">
                  {{p_data.info}}
                </el-col>
              </el-row>
            </div>

            <div style="margin-top: 20px">
              <el-row>
                <el-col :span="8">
                  发布日期：{{p_data.create_time}}
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-view" style="font-size: 16px"></i> {{p_data.view}}
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-view" style="font-size: 16px"></i> {{p_data.praise}}
                </el-col>
                <el-col :span="12" style="text-align: right">
                  <el-button size="small" type="primary" @click="updateProduct">修改产品信息</el-button>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 产品表单 -->
      <div class="page-card__body" v-else-if="UpdateDetailShow==2">
        <el-form :model="productForm" label-width="120px" :rules="rules" ref="productForm">
          <el-row :gutter="20" style="text-align: left;font-size: 14px;line-height: 30px">
            <el-col :span="6">
              <el-form-item prop="img" label-width="0px">
                <el-image
                  :src="updateImg"></el-image>
                <el-upload
                  class="avatar-uploader"
                  :action="imagesrc"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"

                  :headers="headers"
                  :before-upload="beforeAvatarUpload">
                  <el-button size="small" type="primary" round>点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">最佳展示尺寸：1:1，建议500 x 500像素以上</div>
                </el-upload>
              </el-form-item>

            </el-col>

            <el-col :span="18">

              <el-form-item prop="title" label="产品名称：">
                <el-input placeholder="请填写产品名称" v-model="productForm.title"></el-input>
              </el-form-item>


              <el-form-item prop="type" label="产品分类：">
                <el-radio-group v-model="productForm.type">
                  <el-radio label="紧固件"></el-radio>
                  <el-radio label="设备"></el-radio>
                  <el-radio label="模具"></el-radio>
                  <el-radio label="表面处理"></el-radio>
                  <el-radio label="原材料"></el-radio>
                  <el-radio label="检测"></el-radio>
                  <el-radio label="其他"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item prop="info" label="产品介绍：">
                <el-input type="textarea" :rows="6" placeholder="请填写产品介绍" v-model="productForm.info"></el-input>
              </el-form-item>

              <el-row style="margin: 20px;text-align: center">
                <el-button type="primary" round @click="p_onsubmit('productForm')">确定发布</el-button>
                <el-button round @click="updateProduct">取消修改</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "productDetail",
    data() {
      return {
        UpdateDetailShow: 1,
        p_id: '',
        p_data: [],
        headers: {"Authorization": "JWT " + localStorage.getItem('token')},
        imagesrc: this.baseUrl + "/user/uploadfile/product/",
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/',
        img: "",
        updateImg: "",

        productForm: {
          title: '',
          info: '',
          type: '',
          img: "",
        },
        rules: {
          img: [
            {required: true, message: '请输入产品图', trigger: 'blur'},
          ],

          title: [
            {required: true, message: '请输入产品名称', trigger: 'blur'},
          ],
          type: [
            {required: true, message: '请输入产品分类', trigger: 'blur'},
          ],
          info: [
            {required: true, message: '请输入产品介绍', trigger: 'blur'},
          ],
        },
        type: [],

      }
    },
    mounted() {
      this.UpdateDetailShow = this.$route.query.type;
      this.p_id = this.$route.query.id;
      this.detailData()
    },

    methods: {

      // 提交产品修改表单
      p_onsubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = this.p_id;
            let url = this.baseUrl + '/user/products/' + id + '/';
            api.patchData(url, {
              title: this.productForm.title,
              info: this.productForm.info,
              type: this.productForm.type,
              img: this.productForm.img,
            }).then((res) => {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.detailData();
              this.updateProduct()
            })
          }
        })
      },

      // 获取产品详情数据
      detailData() {
        let id = this.p_id;
        let url = this.baseUrl + '/user/products/' + id + '/';
        api.fetchData(url).then(res => {
          this.p_data = res;
          this.img = this.imgUrl + this.p_data.img;
          this.productForm = res;
          this.updateImg = this.imgUrl + this.productForm.img
        })
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {
        let imageUrl = URL.createObjectURL(file.raw);
        this.productForm.img = res.filename;
        this.updateImg = this.imgUrl + this.productForm.img
      },

      // 图片上传前校验
      beforeAvatarUpload(file) {
      },

      // 切换详情/编辑视图
      updateProduct() {
        if (this.UpdateDetailShow == 1) {
          this.UpdateDetailShow = 2
        } else {
          this.UpdateDetailShow = 1
        }
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/productDetail.vue